var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getLocal, LOCAL_STORAGE_KEYS, setLocal } from "./data/localStorageHelpers";
import { integrationsEventQueryParamsFound, setIntegrationConfig } from "./store/Integrations/actions";
import { INTEGRATIONS_LOCAL_STORAGE_KEYS } from "./store/Integrations/types";
var AppListener = function () {
    var dispatch = useDispatch();
    var search = useLocation().search;
    useEffect(function () {
        //dispatch(attachIntegrationHelpers());
        window.initializeReferralRock = function (config) {
            dispatch(setIntegrationConfig({
                key: "REFERRAL_ROCK",
                config: config,
            }));
            if (config.fieldLabel) {
                setLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_FIELD, config.fieldLabel);
            }
            var referralRockCode = getLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_CODE);
            if (referralRockCode) {
                var codes = Object.keys(config.codes);
                codes.forEach(function (code) {
                    if (referralRockCode.toLowerCase().startsWith("".concat(code.toLowerCase()))) {
                        setLocal(LOCAL_STORAGE_KEYS.PROMO_SLIPSTREAM, config.codes[code].promoCode, 60 * 24);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.referralJS = window.referralJS !== null && window.referralJS !== undefined ? window.referralJS : {};
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.referralJS.scriptConfig = {
                parameters: {
                    src: "//".concat(config.domain, ".referralrock.com/ReferralSdk/referral.js"),
                    transactionKey: config.transactionKey,
                },
            };
            (function (f, r, n) {
                var _a;
                var b = f.createElement(r);
                var y = f.getElementsByTagName(r)[0];
                b.async = true;
                b.src =
                    n +
                        "?referrer=" +
                        encodeURIComponent(window.location.origin + window.location.pathname).replace(/[!'()*]/g, escape);
                b.id = "RR_DIVID_V5";
                b.setAttribute("transactionKey", config.transactionKey);
                (_a = y.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(b, y);
            })(document, "script", "//".concat(config.domain, ".referralrock.com/ReferralSdk/referral.js"));
        };
    }, []);
    function paramsToObject(entries) {
        var e_1, _a;
        var result = {};
        try {
            for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                var _b = __read(entries_1_1.value, 2), key = _b[0], value = _b[1];
                // each 'entry' is a [key, value] tupple
                result[key] = value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return result;
    }
    useEffect(function () {
        dispatch(integrationsEventQueryParamsFound(search.toLowerCase()));
        var params = new URLSearchParams(search);
        var objectToSet = paramsToObject(params.entries());
        if (Object.values(objectToSet).length > 0) {
            setLocal(LOCAL_STORAGE_KEYS.QUERY_VALUES, JSON.stringify(objectToSet), 60 * 60 * 4);
        }
    }, [search]);
    return null;
};
export default AppListener;
